import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { Constant } from 'src/app/Common/constant';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { ErrorLog } from 'src/app/Model/Common/error-log';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { RaiseDisputeOnShippingDto } from 'src/app/Model/Shipping/raise-dispute-on-shipping-dto';
import { ShippingFareShippingWise } from 'src/app/Model/Shipping/shipping-fare-shipping-wise';
import { TripsAndShippingsDto } from 'src/app/Model/Shipping/trips-and-shippings-dto';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';

@Component({
  selector: 'app-trips',
  templateUrl: './trips.component.html',
  styleUrls: ['./trips.component.css']
})
export class TripsComponent {

  createSetUpForm: UntypedFormGroup;
  currDate = new Date();
  riderEmail: string;
  tripsAndShippings: TripsAndShippingsDto[] = [];
  tripsNoList: string[] = [];
  shippingNoList: string[] = [];
  shippingFareShippingWise: ShippingFareShippingWise[] = [];
  raiseDisputeOnShippingDto: RaiseDisputeOnShippingDto = new RaiseDisputeOnShippingDto();

  constant: Constant = new Constant();
  errorLog: ErrorLog = new ErrorLog();


  private getTripDataSubscription: Subscription;
  private getDeliveryDetailsByRiderSubscription: Subscription;
  private saveRaiseDisputeSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;


  constructor(
    private apiUrl: APIFactoryEndPoints,
    public persistenceService: LocalStorageService,
    private toastService: ToastrService,
    private formBuilder: UntypedFormBuilder,
    private shippingManagerService: ShippingManagerService,
    // private containerService: MainContainerService,

  ) {

  }

  ngOnInit(): void {
    this.riderEmail = JSON.parse(this.persistenceService.get("google_email"));
    this.onCreateSetUp();
    // this.onDateChange();
  }

  ngOnDestroy() {
    if (this.getTripDataSubscription !== undefined)
    this.getTripDataSubscription.unsubscribe();

    if (this.getDeliveryDetailsByRiderSubscription !== undefined)
    this.getDeliveryDetailsByRiderSubscription.unsubscribe();

    if (this.saveRaiseDisputeSubscription !== undefined)
    this.saveRaiseDisputeSubscription.unsubscribe();
  }

  onCreateSetUp() {
    this.createSetUpForm = this.formBuilder.group({
      fromDate: [new Date(), Validators.required],
      tripNo: ["", Validators.required],
      shippingNo: ["", Validators.required]
    })
  }

  // onDateChange() {
  //   this.createSetUpForm.get('tripNo').reset();
  //   this.createSetUpForm.get('shippingNo').reset();


    // this.tripsAndShippings = [];
    // this.tripsNoList = [];
    // this.shippingNoList = [];
    // this.shippingFareShippingWise = [];

    // let momentDate = new Date(this.createSetUpForm.get('fromDate').value);
    // let formattedFromDate = moment(momentDate).format("YYYY-MM-DD");

    // this.getTripDataSubscription = this.shippingManagerService.getTripNosAndShippingNoByEmpIdAndDate(this.apiUrl.getTripNoByRiderOnDate, this.riderEmail, formattedFromDate).subscribe((data) => {
    //   if (data.length > 0) {
    //     this.tripsAndShippings = data;
    //     this.tripsNoList = this.tripsAndShippings.map(e => e.trips);
    //   }
    //   else {
    //     this.toastService.showErrorToast(this.constant.noDataAvailableToastDateRange);
    //   }
    // });
  // }

  onFetchClick(){
    this.createSetUpForm.get('tripNo').reset();
    
    this.tripsAndShippings = [];
    this.tripsNoList = [];
    this.shippingNoList = [];
    this.shippingFareShippingWise = [];

    let momentDate = new Date(this.createSetUpForm.get('fromDate').value);
    let formattedFromDate = moment(momentDate).format("YYYY-MM-DD");

    this.getTripDataSubscription = this.shippingManagerService.getTripNosAndShippingNoByEmpIdAndDate(this.apiUrl.getTripNoByRiderOnDate, this.riderEmail, formattedFromDate).subscribe((data) => {
      if (data.length > 0) {
        this.tripsAndShippings = data;
        this.tripsNoList = this.tripsAndShippings.map(e => e.trips);
      }
      else {
        this.toastService.showErrorToast(this.constant.noDataAvailableToastDateRange);
      }
    });
  }

  onTripSelect(tripNo: string) {
    this.createSetUpForm.get('shippingNo').reset();

    this.shippingNoList = [];
    this.tripsAndShippings.forEach(element => {
      let ship: string[] = element.shippings;
      ship.forEach(item => {
        if (element.trips == tripNo) {
          if (item != "Return To Parent") {
            this.shippingNoList.push(item);
          }
        }
        else {
          if (tripNo == "All") {
            if (item != "Return To Parent") {
              this.shippingNoList.push(item);
            }
          }
        }
      })
    })
  }

  onViewClick() {
    if (this.createSetUpForm.invalid) {
      this.toastService.showErrorToast(this.constant.invalidFormToast);
      return;
    }
    let momentDate = new Date(this.createSetUpForm.get('fromDate').value);
    let formattedFromDate = moment(momentDate).format("YYYY-MM-DD");

    let tripNo = this.createSetUpForm.get('tripNo').value;
    let shippingNo = this.createSetUpForm.get('shippingNo').value;

    this.getDeliveryDetailsByRiderSubscription = this.shippingManagerService.getDeliveryFareDetailsByRider(this.apiUrl.getDeliveryFareDetailsByRiderEmailIdAndDateRange, this.riderEmail, formattedFromDate, tripNo, shippingNo).subscribe((data) => {
      if (data.length > 0) {
        this.shippingFareShippingWise = data;
      }
      else {
        this.toastService.showErrorToast(this.constant.noDataAvailableToast);
      }
    });
  }

  onSaveRaiseDisputeClick() {
    let dispute: RaiseDisputeOnShippingDto = new RaiseDisputeOnShippingDto();
    dispute.onDateTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss");
    dispute.shippingNo = this.shippingFareShippingWise[0].usedForRefNo;
    dispute.currentStatus = "Dispute";
    dispute.reason = "NA";
    dispute.finalAmount = 0;
    dispute.additionalAmountIfAny = 0;
    dispute.serviceManID = this.shippingFareShippingWise[0].serviceManID;
    dispute.amountAsPerSuggestedRoute = this.shippingFareShippingWise[0].netAmount;

    this.saveRaiseDisputeSubscription = this.shippingManagerService.saveRaiseDispute(this.apiUrl.insertRaiseDispute, dispute).subscribe((data) => {
      if (data) {
        this.toastService.showSuccessToast(this.constant.requestraiseToast)
      }
    });
    this.onViewClick();
  }

  // insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
  //   this.errorLog.userId = this.persistenceService.get('userId');
  //   this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
  //   this.errorLog.moduleName = "Shipping Summary Report";
  //   this.errorLog.errorMethod = errorMethod;
  //   this.errorLog.platform = "Web";
  //   if (error?.error?.message || error?.error?.message != '')
  //     this.errorLog.errorDetails = error.error.message;
  //   else
  //     this.errorLog.errorDetails = error.message;

  //   this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiUrl.insertErrorLog, this.errorLog).subscribe((data: any) => {
  //   });
  // }


}
